export default __webpack_public_path__ + "static/media/(20).c7f7cfee.jpg";